import { CurrentPersonResponseDto } from '@common/models/current-user/current-person.dto';
import { CurrentPersonVm } from '@common/models/current-user/current-person.vm';

export class CurrentPersonMapper {
  static mapResponseToVm(response: CurrentPersonResponseDto): CurrentPersonVm {
    return {
      uuid: response.uuid,
      name: response.nombre,
      dni: response.dni,
      fatherLastname: response.apellido_paterno,
      motherLastname: response.apellido_materno,
      birthDate: response.fecha_nacimiento,
      phone: response.telefono,
      email: response.email,
      companyUuid: response.id_empresa,
    };
  }
}
